import React from 'react';
import PropTypes from 'prop-types';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer
} from 'recharts';

const AssessmentBarChart = ({ data }) => (
  <ResponsiveContainer height={300} width="100%">
    <BarChart data={data} margin={{ top: 20, left: -10 }}>
      <CartesianGrid strokeDasharray="3 3" />
      <XAxis dataKey="categoryName" />
      <YAxis 
        yAxisId="left" 
        orientation="left" 
        stroke="hsl(159, 100%, 51%)" 
        style={{ direction: "ltr", marginLeft: '5px' }}
        domain={[0, 100]}
        label={{ value: 'Score (%)', angle: -90, position: 'insideLeft' }}
      />
      <Tooltip 
        formatter={(value) => [`${value}%`, 'Score']}
        labelFormatter={(label) => `Category: ${label}`}
      />
      <Bar 
        yAxisId="left" 
        dataKey="score" 
        fill="hsl(159, 100%, 51%)" 
        name="Score"
        radius={[8, 8, 0, 0]}
      />
    </BarChart>
  </ResponsiveContainer>
);

AssessmentBarChart.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({
    categoryName: PropTypes.string.isRequired,
    score: PropTypes.number.isRequired,
  })).isRequired,
};

export default AssessmentBarChart;

